import { type SparkleCircleImageProps } from "./SparkleCircleImage.types";
import {
  SparkleCircleImageWrapper,
  SparklesImageWrapper,
  ImageContainer,
} from "./SparkleCircleImage.styles";
import { getAssetUrl } from "../../utils/common";

export default function SparkleCircleImage({
  imgSrc,
  divProps,
  imgProps,
  sparkleColor,
}: SparkleCircleImageProps) {
  return (
    <SparkleCircleImageWrapper {...divProps}>
      <ImageContainer>
        <img
          {...imgProps}
          src={imgSrc}
          onError={(e) =>
            (e.currentTarget.src = getAssetUrl("Wishlink-logo.png"))
          }
          alt="sparkle-image"
        />
      </ImageContainer>
      <Sparkles color={sparkleColor || "#FE0000"} />
    </SparkleCircleImageWrapper>
  );
}

const Sparkles = ({ color }: { color: string }) => {
  return (
    <SparklesImageWrapper>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 101 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        <path
          d="M17.9899 3.6743L18.371 0L18.7513 3.66705C18.8299 4.42449 19.4323 5.01572 20.1809 5.06998L22.5 5.2381L20.0881 5.58778C19.3828 5.69004 18.8373 6.26756 18.7664 6.98705L18.371 11L17.9742 6.97354C17.9039 6.26032 17.367 5.68574 16.669 5.57675L14.5 5.2381L16.5687 5.07659C17.3138 5.01843 17.9116 4.42852 17.9899 3.6743Z"
          fill={color}
        />
        <path
          d="M82.7348 11.6785L83.3065 6L83.877 11.6673C83.9948 12.8378 84.8985 13.7516 86.0213 13.8354L89.5 14.0952L85.8822 14.6357C84.8242 14.7937 84.0059 15.6862 83.8996 16.7982L83.3065 23L82.7113 16.7773C82.6059 15.675 81.8005 14.7871 80.7535 14.6186L77.5 14.0952L80.6031 13.8456C81.7207 13.7558 82.6175 12.8441 82.7348 11.6785Z"
          fill={color}
        />
        <path
          d="M93.7348 41.6785L94.3065 36L94.877 41.6673C94.9948 42.8378 95.8985 43.7516 97.0213 43.8354L100.5 44.0952L96.8822 44.6357C95.8242 44.7937 95.0059 45.6862 94.8996 46.7982L94.3065 53L93.7113 46.7773C93.6059 45.675 92.8005 44.7871 91.7535 44.6186L88.5 44.0952L91.6031 43.8456C92.7207 43.7558 93.6175 42.8441 93.7348 41.6785Z"
          fill={color}
        />
        <path
          d="M7.47974 28.6826L8.24194 21L9.00263 28.6675C9.15975 30.2512 10.3646 31.4874 11.8617 31.6009L16.5 31.9524L11.6762 32.6835C10.2656 32.8974 9.17454 34.1049 9.03276 35.6093L8.24194 44L7.44845 35.581C7.3079 34.0898 6.23405 32.8884 4.83793 32.6605L0.5 31.9524L4.63749 31.6147C6.12762 31.4931 7.32329 30.2596 7.47974 28.6826Z"
          fill={color}
        />
        <path
          d="M80.9899 62.6743L81.371 59L81.7513 62.667C81.8299 63.4245 82.4323 64.0157 83.1809 64.07L85.5 64.2381L83.0881 64.5878C82.3828 64.69 81.8373 65.2676 81.7664 65.9871L81.371 70L80.9742 65.9735C80.9039 65.2603 80.367 64.6857 79.669 64.5767L77.5 64.2381L79.5687 64.0766C80.3138 64.0184 80.9116 63.4285 80.9899 62.6743Z"
          fill={color}
        />
      </svg>
    </SparklesImageWrapper>
  );
};
